import { useState } from 'react'
import { useActivity } from '../../api/queries'
import { Card, EmptyState, ErrorBox, Loading } from '../../components/ui'
import { formatDateTime } from '../../lib/format'

/** Aktivitetsloggen (kravspec afsnit 11). Kun læsning - loggen kan ikke redigeres. */
export function ActivityPage() {
  const [page, setPage] = useState(1)
  const [entityType, setEntityType] = useState('')
  const { data, isLoading, error } = useActivity({ page, pageSize: 50, entityType: entityType || undefined })

  return (
    <Card title="Aktivitetslog">
      <div className="row" style={{ marginBottom: 12 }}>
        <select style={{ maxWidth: 200 }} value={entityType} onChange={(e) => { setEntityType(e.target.value); setPage(1) }}>
          <option value="">Alle typer</option>
          <option value="Project">Projekter</option>
          <option value="Task">Opgaver</option>
          <option value="Screen">TV-skærme</option>
          <option value="User">Brugere</option>
        </select>
      </div>

      {isLoading && <Loading />}
      {error && <ErrorBox error={error} />}
      {data && data.items.length === 0 && <EmptyState>Ingen logposter.</EmptyState>}

      {data && data.items.length > 0 && (
        <>
          <div className="table-wrap">
            <table className="table">
              <thead>
                <tr>
                  <th>Tidspunkt</th>
                  <th>Bruger</th>
                  <th>Handling</th>
                  <th>Fra</th>
                  <th>Til</th>
                </tr>
              </thead>
              <tbody>
                {data.items.map((entry) => (
                  <tr key={entry.id}>
                    <td className="small muted" style={{ whiteSpace: 'nowrap' }}>{formatDateTime(entry.createdAt)}</td>
                    <td className="small">{entry.actorName}</td>
                    <td className="small">{entry.summary ?? `${entry.action} ${entry.entityName ?? ''}`}</td>
                    <td className="tiny muted">{entry.oldValue ?? '-'}</td>
                    <td className="tiny muted">{entry.newValue ?? '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="row" style={{ marginTop: 12 }}>
            <button className="btn btn--sm" disabled={page === 1} onClick={() => setPage((p) => p - 1)}>
              Forrige
            </button>
            <span className="small muted">
              Side {data.page} · {data.total} poster
            </span>
            <button
              className="btn btn--sm"
              disabled={data.page * data.pageSize >= data.total}
              onClick={() => setPage((p) => p + 1)}
            >
              Næste
            </button>
          </div>
        </>
      )}
    </Card>
  )
}
